import { useMutation } from '@apollo/client'
import { message } from 'antd'

import { getUserTypeEndpoint } from 'utils/user'
import { appLocalAccessToken } from 'utils/localService'

import MUTATION_DOCUMENT from './changePassword'

import type { APIPayloadResponse, GraphQLServiceMutationHook } from 'graphQL/graphQL-service-hook'
import type { MyProfileAPIPayload } from 'graphQL/useGetMyProfile/interface'

interface ChangePasswordData {
  changePassword: APIPayloadResponse<MyProfileAPIPayload>
}

interface ChangePasswordVars {
  password: string
  newPassword: string
  confirmPassword: string
}

const useChangePassword: GraphQLServiceMutationHook<ChangePasswordData, ChangePasswordVars> = (options) => {
  return useMutation(MUTATION_DOCUMENT, {
    context: {
      uri: getUserTypeEndpoint(appLocalAccessToken.get()),
    },
    onError(error) {
      message.error(error.message)
    },
    ...options,
  })
}

export default useChangePassword
